module.exports = __webpack_public_path__ + "img/Dani Ceballos.1bcd1eb3.png";